import * as React from 'react'
import classNames from 'classnames'
import { AppContext } from '../../context/appContext'
import { ICloseButton, ISidePanel, ITitle, IWrapper } from './interface'
import './SidePanel.scss'

const { useContext, useEffect } = React

const SidePanel = ({ children, data }: ISidePanel) => {
  const { removeSidePanel } = useContext(AppContext)

  useEffect(() => {
    document.addEventListener('keydown', e => getKeyAndRemoveSidePanel(e))
    return () => document.removeEventListener('keydown', getKeyAndRemoveSidePanel)
  })

  const clickOutsideCloseSidePanel = (e: any) => {
    if (e) {
      if (e.target.className.includes('SidePanel__wrapper')) {
        removeSidePanel()
      }
    }
  }

  const getKeyAndRemoveSidePanel = (e: KeyboardEvent) => {
    if (e.keyCode === 27) {
      removeSidePanel()
    }
  }

  return (
    <Wrapper
      className={data.className || ''}
      onClick={(e: React.MouseEvent<HTMLElement>) => clickOutsideCloseSidePanel(e)}
    >
      <Content>
        <CloseButton onClick={removeSidePanel} />
        <Header>
          <Title text={data.title || ''} />
        </Header>
        <Body>{children}</Body>
      </Content>
    </Wrapper>
  )
}

export default SidePanel

const Body = ({ children }: any) => <div className='SidePanel__body'>{children}</div>

const CloseButton = ({ onClick }: ICloseButton) => (
  <div className='SidePanel__button--close' onClick={(e: React.MouseEvent<HTMLElement>) => onClick(e)}>
    <i className='icon-close'></i>
  </div>
)

const Content = ({ children }: any) => <div className='SidePanel__content'>{children}</div>

const Header = ({ children }: any) => <div className='SidePanel__header'>{children}</div>

const Title = ({ text }: ITitle) => (text ? <p className='SidePanel__title'>{text}</p> : null)

const Wrapper = ({ children, className, onClick }: IWrapper) => (
  <div
    className={classNames('SidePanel__wrapper', className)}
    onClick={(e: React.MouseEvent<HTMLElement>) => onClick(e)}
  >
    {children}
  </div>
)
